<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button
          class="btn btn-outline btn-fill btn-round btn-icon d-none d-lg-block"
          @click="minimizeSidebar"
        >
          <i :class="$sidebar.isMinimized ? 'fa fa-ellipsis-v' : 'fa fa-navicon'"></i>
        </button>
      </div>
      <div >
        <span style="font-size: 0.75rem">Bem vindo, {{$store.state.general.permission.username_do_usuario}}!</span>
        <!-- <span style="font-size: 0.75rem" v-if="$store.state.general.permission.grupos_do_usuario.length > 1"
        >Bem vindo, Fulano! Seus grupos são: <span v-for="x in $store.state.general.permission.grupos_do_usuario" :key="x.index">{{x}},&nbsp;</span></span>
        <span style="font-size: 0.75rem" v-if="$store.state.general.permission.grupos_do_usuario.length < 2"
        >Bem vindo, Fulano! Seu grupo é: <span v-for="x in $store.state.general.permission.grupos_do_usuario" :key="x.index">{{x}}&nbsp;</span></span> -->
      </div>
      <div v-if="showItem && compName" >
        <span style="font-size: 0.75rem; position:absolute;
                    left: 40%; margin-top: -5px"> <b>Visualização da empresa:</b> {{compName}}</span>
      </div>
      <button
        type="button"
        class="navbar-toggler navbar-toggler-right"
        :class="{toggled: $sidebar.showSidebar}"
        aria-expanded="false"
        @click="toggleSidebar"
      >
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <!-- <ul class="nav navbar-nav mr-auto">
          <form class="navbar-form navbar-left navbar-search-form" role="search">
            <div class="input-group">
              <label for="searchInput"></label>
              <i class="nc-icon nc-zoom-split"></i>
              <input
                id="searchInput"
                type="text"
                value
                class="form-control"
                placeholder="Search..."
              >
            </div>
          </form>
        </ul>-->
        <ul class="navbar-nav">
          <!-- <drop-down>
            <i slot="title" class="nc-icon nc-planet"></i>
            <a class="dropdown-item" href="#">Create New Post</a>
            <a class="dropdown-item" href="#">Manage Something</a>
            <a class="dropdown-item" href="#">Do Nothing</a>
            <a class="dropdown-item" href="#">Submit to live</a>
            <li class="divider"></li>
            <a class="dropdown-item" href="#">Another action</a>
          </drop-down>-->
          <!-- <drop-down>
            <template slot="title">
              <i class="nc-icon nc-bell-55"></i>
              <span class="notification">5</span>
              <span class="d-lg-none">Notification</span>
            </template>
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </drop-down>-->
          <drop-down position="right">
            <i slot="title" class="nc-icon nc-bullet-list-67"></i>

            <!-- <a class="dropdown-item" href="#">
              <i class="nc-icon nc-email-85"></i> Messages
            </a>
            <a class="dropdown-item" href="#">
              <i class="nc-icon nc-umbrella-13"></i> Help Center
            </a>-->
            <router-link to="/app/settings/password" class="dropdown-item">
              <i class="nc-icon nc-lock-circle-open padded-icon"></i> Alterar Senha
            </router-link>

            <router-link to="/app/permissions" class="dropdown-item" 
                          v-if="permission('access_permissions')">
              <i  class="nc-icon nc-badge padded-icon"></i> Permissões
            </router-link>
            
      
            <el-button icon="nc-icon nc-puzzle-10 padded-icon"
              @click="changeCia = true"
              v-if="showItem"
              type="text"
              class="dropdown-item" 
             > 
              <span style="font-size: 1rem; margin-right: 10px; position: relative; top: 5px">
                Empresa atual
              </span> 
            </el-button>
              
            <router-link to="/app/featureflags" class="dropdown-item" 
                          v-if="showItem">
              <i  class="nc-icon nc-key-25 padded-icon"></i> Feature Flag
            </router-link>

            <router-link to="/app/users" class="dropdown-item" v-if="permission('access_user')">
              <i class="nc-icon nc-circle-09 padded-icon"></i> Usuários
            </router-link>

            <router-link to="/app/mpago" class="dropdown-item" v-if="company.payment_methods === 'MP'" >
              <i class="nc-icon nc-credit-card padded-icon " ></i> Mercado Pago
            </router-link>

            <!-- <router-link to="/app/visuais" class="dropdown-item" >
              <i class="nc-icon nc-ruler-pencil padded-icon " ></i> Visual Machine
            </router-link> -->


            <div class="divider"></div>
            <!-- <a class="dropdown-item" href="#">
              <i class="nc-icon nc-lock-circle-open"></i> Lock Screen
            </a>-->
            <a class="dropdown-item text-danger" href @click="logout">
              <i class="nc-icon nc-button-power"></i> Log out
            </a>
          </drop-down>
        </ul>
      </div>
      <el-dialog
        :close-on-click-modal='false'
        :close-on-press-escape="false"
        :show-close='false'
        center :visible.sync="changeCia" width="400px" title="Empresas">
            <div class="col-sm-12">
              <label class="col-sm-10">Escolha a empresa desejada</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                filterable
                placeholder="Digite para filtar"
                v-model="smartmachCia"
              >
                <el-option
                  v-for="option in companies"
                  class="select-danger"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
          <button 
            style="position: relative; left: 43%; margin: 0; margin-top: 30px"
            class="btn btn-success" @click="chooseCia()">OK</button>
        </el-dialog>
    </div>
  </nav>
</template>
<script>
import {Button, Dialog, Select, Option} from "element-ui"
import swal from "sweetalert2";
export default {
  components: {
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Option.name]: Option,
    [Select.name]: Select
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    showItem() {
      const smartmach = localStorage.getItem("smartmach")
      if (smartmach == 'true') {
        return true
      } else {
        return false
      }
    },
    showMatriz () {
      this.parentCompany = localStorage.getItem("parent_company")
      if (localStorage.getItem("parent_company")) {
        return true
      } else {
        return false
      }
    },
    companies () {
      return this.$store.state.company.companies
    }
  },
  data() {
    return {
      activeNotifications: false,
      company: [],
      smartmachCia: '',
      selectCia: [],
      compName: '',
      changeCia: false,
      showMP: false,
      parentCompany: ''
    };
  },
  mounted() {
    this.$sidebar.toggleMinimize()
    const smartmach = localStorage.getItem("smartmach")
    const ciaName = localStorage.getItem('smartmachCia')
    const ciaID = localStorage.getItem('smartmachCiaID')
    if (smartmach === 'true') {
      if (ciaID !== null) {
        this.smartmachCia = Number(ciaID)
        this.compName = ciaName
        this.getMP(ciaID)
      } else {
        this.changeCia = true
      }
    } else {
      if (this.$store.state.auth.company !== undefined){
        if (this.$store.state.auth.company != null) {
          this.$store.dispatch('company/get', {id: this.$store.state.auth.company}).then(data => {
            this.company = data
            if (data.payment_methods === 'MP') {
              this.showMP = true
            }
          })
          console.log('store', this.$store.state)
        }
      }
    }
    this.$watch('compName', () =>{
      this.getMP(this.smartmachCia)
    })
    // alert(localStorage.getItem("smartmachCia"))
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getMP (id) {
      this.$store.dispatch('company/get', {id: id}).then(data => {
        this.company = data
        if (data.payment_methods === 'MP') {
          this.showMP = true
        }
      })
    },
    permission (permissao) {
      if (this.$store.state.general.permission.permissoes_do_usuario !== undefined) {
        var x = this.$store.state.general.permission.permissoes_do_usuario.filter(el => {
          if (el == permissao) {
            return true
          } 
        })
        if (x.length > 0) {
          return true
        }
        if (this.smartmachCia) {
          return true
        }
        if (this.parentCompany !== null) {
          return true
        }
      }
    },
    chooseCia () {
      this.selectCia = this.companies.filter(v => {
        if (v.id == this.smartmachCia) {
          return v
        }
      })
      this.changeCia = false
      localStorage.setItem("smartmachCia", this.selectCia[0].name)
      localStorage.setItem("smartmachCiaID", this.selectCia[0].id)
      this.compName = this.selectCia[0].name
      this.$emit('csmartmach', this.selectCia[0].id)
      window.location.reload(false)
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    logout() {
      this.$store.dispatch("auth/logout");
    }
  }
};
</script>
<style>
.padded-icon {
  font-size: 18px;
  text-align: center;
  line-height: 25px;
  float: left;
  padding-right: 10px;
}
</style>
